import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  ActionsEnum,
  FetchLabelsError,
  FetchLabelsSuccess,
  SendEmailError,
} from './refer-a-friend-data.actions';
import { ReferAFriendLabels } from './refer-a-friend-labels.model';

// feature name
export const FEATURE_NAME = 'refer-a-friend-data';

// state interface
export interface IState {
  labels: ReferAFriendLabels;
  labelsFetched: boolean;
  error: any[];
}

// initial state of store
export const initialState: IState = {
  labels: null,
  labelsFetched: false,
  error: null,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.FETCH_LABELS]: function (state: IState): IState {
      return {
        ...state,
        labels: null,
        error: null,
        labelsFetched: false,
      };
    },
    [ActionsEnum.FETCH_LABELS_SUCCESS]: function (
      state: IState,
      { payload }: FetchLabelsSuccess
    ): IState {
      const { referAFriendLabels } = payload;
      return {
        ...state,
        labels: referAFriendLabels,
        error: null,
        labelsFetched: true,
      };
    },
    [ActionsEnum.FETCH_LABELS_ERROR]: function (
      state: IState,
      { payload }: FetchLabelsError
    ): IState {
      const { error } = payload;

      return {
        ...state,
        labels: null,
        error,
        labelsFetched: true,
      };
    },
    [ActionsEnum.SEND_EMAIL]: function (state: IState): IState {
      return {
        ...state,
        error: null,
      };
    },
    [ActionsEnum.SEND_EMAIL_SUCCESS]: function (state: IState): IState {
      return {
        ...state,
        error: null,
      };
    },
    [ActionsEnum.SEND_EMAIL_ERROR]: function (
      state: IState,
      { payload }: SendEmailError
    ): IState {
      const { error } = payload;

      return {
        ...state,
        error,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getLabels = createSelector(
  selectFeature,
  (state: IState) => state.labels
);
export const getLabelsFetched = createSelector(
  selectFeature,
  (state: IState) => state.labelsFetched
);
export const getError = createSelector(
  selectFeature,
  (state: IState) => state.error
);
